PJQ.views.settings.SignatureEditInput = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'signature-edit-input'),
        model: null,
        signature: null
    },
    events: {
        'click .btn-manage-signature': 'manageSignature'
    },
    beforeFirstRender: function () {
        this.signature = this.options.signature;
    },
    renderData: function() {
        return {
            signature: this.signature
        }
    },
    manageSignature: function() {
        new PJQ.views.signatures.SignatureSubmitModal({
            headerSubText: this.options.headerSubText,
            fetchSignature: false,
            signature: this.signature,
            onSubmit: _.bind(function (signature, cb) {
                if(typeof this.options.onSave === 'function'){
                    this.options.onSave(signature);
                }
                this.signature = signature;
                this.render();
                cb();
            }, this)
        });
    }
});